import { createTheme, type MantineColorsTuple } from '@mantine/core';

/**
 * Color palette derived from the morrell_dev "M" logo (pink / orange / teal).
 * Used both as the primary brand color (`mdev` = pink) and as per-app accent
 * options consumed elsewhere (e.g. nav highlights, app tile borders).
 */

const mdevPink: MantineColorsTuple = [
  '#fff0f3',
  '#ffd9e1',
  '#ffb1c1',
  '#ff87a0',
  '#ff6082',
  '#f8204d',
  '#d81841',
  '#b41435',
  '#8e1029',
  '#680b1f',
];

const mdevOrange: MantineColorsTuple = [
  '#fff5e5',
  '#ffe4bb',
  '#ffcc85',
  '#ffb14e',
  '#ff9b22',
  '#f7951c',
  '#d27d14',
  '#a6620e',
  '#7a480a',
  '#562f06',
];

const mdevTeal: MantineColorsTuple = [
  '#e6f5f7',
  '#bfe3e8',
  '#8fcbd3',
  '#5db1bb',
  '#34a0ac',
  '#46a5ab',
  '#1b6772',
  '#15525b',
  '#103e45',
  '#0a2a2f',
];

export const theme = createTheme({
  primaryColor: 'mdev',
  colors: {
    mdev: mdevPink,
    mdevOrange,
    mdevTeal,
  },
  primaryShade: { light: 6, dark: 5 },
  defaultRadius: 'md',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Inter", "Helvetica Neue", system-ui, sans-serif',
  headings: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Inter", "Helvetica Neue", system-ui, sans-serif',
    fontWeight: '600',
  },
});

/** Convenience map for per-app accent overrides. */
export const APP_ACCENTS = {
  pink: 'mdev',
  orange: 'mdevOrange',
  teal: 'mdevTeal',
} as const;
